/**
 * This is a "controlled" Select component, made to work with
 * react-hooks-form.
 */
import React from 'react';
import { Controller } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import PropTypes from 'prop-types';

export default function ControlledRadioGroup({
  control,
  defaultValue = '',
  options = [],
  name,
  row = false,
  rules = null,
  shouldUnregister = false,
  ...rest
}) {
  return (
    <Controller
      defaultValue={defaultValue}
      {...(rules && { rules })}
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => {
        return (
          <FormControl>
            <RadioGroup onChange={onChange} row={row} value={value} {...rest}>
              {options.map((option) => (
                <FormControlLabel
                  control={<Radio />}
                  data-testid={`element-${option.value}`}
                  key={option.value}
                  label={option.label}
                  value={option.value}
                  disabled={option.disabled ?? false}
                />
              ))}
            </RadioGroup>
          </FormControl>
        );
      }}
      shouldUnregister={shouldUnregister}
    />
  );
}

ControlledRadioGroup.propTypes = {
  ...RadioGroup.propTypes,
  control: PropTypes.object.isRequired,
  defaultValue: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string.isRequired,
  row: PropTypes.bool,
  rules: PropTypes.object,
  shouldUnregister: PropTypes.bool,
};

ControlledRadioGroup.defaultProps = {
  defaultValue: '',
  options: [],
  row: false,
  rules: null,
  shouldUnregister: false,
};
